/*------~+=={    USER ACTIONS    }===~------*/
export const RECEIVE_CURRENT_USER = "RECEIVE_CURRENT_USER";
export const LOGOUT_CURRENT_USER = "LOGOUT_CURRENT_USER";
export const RECEIVE_ERRORS = "RECEIVE_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const VALIDATE_EMAIL = "VALIDATE_EMAIL";
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const EDIT_USER = 'EDIT_USER';

/*------~+=={    CONNECTION ACTIONS    }===~------*/
export const LOAD_CONNECTION_LIST = 'LOAD_CONNECTION_LIST';
export const SELECTED_OPTION = 'SELECTED_OPTION';
export const ADD_MIND_BODY_CONNECTION = 'ADD_MIND_BODY_CONNECTION';
export const SENT_EMAIL_SUCCESS = "SENT_EMAIL_SUCCESS";
export const FETCH_CONNECTIONS = 'FETCH_CONNECTIONS';
export const FETCH_CONNECTION = 'FETCH_CONNECTION';
export const EDIT_CONNECTION = 'EDIT_CONNECTION';
export const NEW_CONNECTION = 'NEW_CONNECTION';

/*------~+=={    TAG ACTIONS    }===~------*/
export const FETCH_TAGS = 'FETCH_TAGS';
export const FETCH_TAG = 'FETCH_TAG';
export const EDIT_TAG = 'EDIT_TAG';

/*------~+=={    UI ACTIONS    }===~------*/
export const SET_PROGRESS_BAR = 'SET_PROGRESS_BAR';
export const SET_NAVIGATION_DRAWER = 'SET_NAVIGATION_DRAWER';
export const REDIRECT = "REDIRECT";


/*------~+=={    TODO: DEPRECATE    }===~------*/
export const INCREMENT = 'INCREMENT';


/*------~+=={    CONTENT ACTIONS    }===~------*/
export const LOAD_CONTENT_LIST = 'LOAD_CONTENT_LIST';
// export const SELECTED_OPTION = 'SELECTED_OPTION';
// export const ADD_MIND_BODY_CONNECTION = 'ADD_MIND_BODY_CONNECTION';
// export const SENT_EMAIL_SUCCESS = "SENT_EMAIL_SUCCESS";
export const FETCH_ALL_CONTENTS = 'FETCH_ALL_CONTENTS';
export const FETCH_CONTENT = 'FETCH_CONTENT';
export const EDIT_CONTENT = 'EDIT_CONTENT';
export const NEW_CONTENT = 'NEW_CONTENT';




